const finance = [
  // {
  //   tabName: "Debit Notes",
  //   page: [
  //     {
  //       name: "Pending Approval",
  //       path: "/finance/debit-notes/pending-approval",
  //       authority: "PORTAL",
  //       rolePermission: "FINANCE_DEBIT_NOTE",
  //     },
  //     {
  //       name: "Approved",
  //       path: "/finance/debit-notes/approved",
  //       authority: "PORTAL",
  //       rolePermission: "FINANCE_DEBIT_NOTE",
  //     },
  //     {
  //       name: "Finished",
  //       path: "/finance/debit-notes/finished",
  //       authority: "PORTAL",
  //       rolePermission: "FINANCE_DEBIT_NOTE",
  //     },
  //   ],
  // },
  {
    tabName: "Settlement Plans",
    page: [
      {
        name: "All",
        path: "/finance/settlement-plans/all",
        authority: "PORTAL",
        rolePermission: "FINANCE_SETTLEMENT_PLANS_ALL",
      },
      {
        name: "Pending Approval",
        path: "/finance/settlement-plans/pending-approval",
        authority: "PORTAL",
        rolePermission: "FINANCE_SETTLEMENT_PLANS_PENDING_APPROVAL",
      },
      {
        name: "Change Log",
        path: "/finance/settlement-plans/change-log",
        authority: "PORTAL",
        rolePermission: "FINANCE_SETTLEMENT_PLANS_CHANGE_LOG",
      },
    ],
  },
  // {
  //   tabName: "Reconciliation",
  //   page: [
  //     // {
  //     //   name: "By Transaction Date",
  //     //   path: "/finance/bankfile/by-transaction-date",
  //     //   authority: "PORTAL",
  //     //   rolePermission: "FINANCE_RECONCILIATION",
  //     // },
  //     {
  //       name: "By Settlement Date",
  //       path: "/finance/bankfile/by-settlement-date",
  //       authority: "PORTAL",
  //       rolePermission: "FINANCE_RECONCILIATION",
  //     },
  //   ],
  // },
  // {
  //   tabName: "Transaction Summary",
  //   page: [],
  //   path: "/finance/transaction-summary",
  //   authority: "PORTAL",
  //   rolePermission: "FINANCE_TRANSACTION_SUMMARY",
  // },
  {
    tabName: "Submissions",
    page: [
      {
        name: "Reconciliation",
        path: "/finance/submission/reconciliation",
        authority: "PORTAL",
        rolePermission: "FINANCE_SUBMISSIONS_RECONCILIATION",
      },
      {
        name: "Bank File",
        path: "/finance/submission/bank-file",
        authority: "PORTAL",
        rolePermission: "FINANCE_SUBMISSIONS_BANK_FILE",
      },
    ],
  },
  {
    tabName: "Refund",
    page: [],
    path: "/finance/refund",
    authority: "PORTAL",
    rolePermission: "FINANCE_REFUND",
  },
  // {
  //   tabName: "Bank Submission",
  //   page: [],
  //   path: "/finance/bank-submission",
  //   authority: "PORTAL",
  //   rolePermission: "FINANCE_BANK_SUBMISSION",
  // },
  // {
  //   tabName: "Merchant MDR",
  //   page: [],
  //   path: "/finance/merchant-mdr",
  //   authority: "PORTAL",
  //   rolePermission: "FINANCE_MERCHANT_MDR",
  // },
  // {
  //   tabName: "Payment Gateway Cost",
  //   page: [],
  //   path: "/finance/payment-gateway-cost",
  //   authority: "PORTAL",
  //   rolePermission: "FINANCE_PAYMENT_GATEWAY_COST",
  // },
  // {
  //   tabName: "FX Rate",
  //   page: [],
  //   path: "/finance/fx-rate",
  //   authority: "PORTAL",
  //   rolePermission: "FINANCE_FX_RATE",
  // },
];

export default finance;
